import React, { useEffect, useState } from "react";
import { CLIENT, REVENUE, SUBSCRIPTION, USER, GEOGRAPHIC } from "../../Constant/constant";
import TableauGraphs from "./TableauGraphs";
import TableauFilters from "./TableauFilters";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { CATEGORY_TAGS_LIST, TABLEAU_REVENUE_GRAPH } from "../../apiClient/apiEndpoints";
import { formatRupees, MuiLoader } from "../../Utils/common";

const navBar = [
  {
    title: "Revenue",
    value: "revenue",
    key: REVENUE,
  },
  {
    title: "User",
    value: "user",
    key: USER,
  },
  {
    title: "Subscriptions",
    value: "subscription",
    key: SUBSCRIPTION,
  },
  {
    title: "Geographic",
    value: "Geographic",
    key: GEOGRAPHIC,
  },
];

const notShowFirstCharOptionsCharts = ["daily"];

const cutomToolTipFormatOptionsMap = {
  [`${USER}location`]: { tooltipFormatter: (val) => `Users: ${val}` },
};

const Tableau = ({ dateRange }) => {
  const [activeTab, setActiveTab] = useState(REVENUE);
  const [activeGraphType, setActiveGraphType] = useState("bar");
  const [graphLabel, setGraphLabel] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [tablueFilter, setTablueFilter] = useState({});
  const [loading, setLoading] = useState(true);
  const [tooltipFormatter, setTooltipFormatter] = useState({ tooltipFormatter: (val) => `₹${val}` });
  const [showFirstChar, setShowFirstChar] = useState(true);
  const [customToolTip, setCustomToolTip] = useState(null);
  const [heatMap, setHeapMap] = useState([]);
  const [dropDownValues, setDropDownValues] = useState([]);

  const getRevenueGraphData = async () => {
    try {
      setLoading(true);
      let params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? dateRange[1] : null,
        filterName: tablueFilter?.filterName || null,
        filterValue: tablueFilter?.filterValue ?? null,
      };
      let data = await apiClient(`${SSO_URL}${TABLEAU_REVENUE_GRAPH}/revenue`, { params });
      if (data) {
        setGraphLabel(data?.map((e) => e.label));
        setGraphData(data?.map((e) => e.value));
        setTooltipFormatter({ tooltipFormatter: (val) => `${formatRupees(val)}` });
        sanitizeChartPropsBeforeDisplay(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserGraphData = async () => {
    try {
      setLoading(true);
      let params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? dateRange[1] : null,
        filterName: tablueFilter?.filterName || null,
        filterValue: tablueFilter?.filterValue ?? null,
      };
      let data = await apiClient(`${SSO_URL}${TABLEAU_REVENUE_GRAPH}/user`, { params });
      if (data) {
        setGraphLabel(data?.map((e) => e.label || ""));
        setGraphData(data?.map((e) => e.value || 0));
        setTooltipFormatter({ tooltipFormatter: (val) => `Users: ${val}` });
        sanitizeChartPropsBeforeDisplay(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSubscriptionGraphData = async () => {
    try {
      setLoading(true);
      let params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? dateRange[1] : null,
        filterName: tablueFilter?.filterName || null,
        filterValue: tablueFilter?.filterValue ?? null,
      };
      let data = await apiClient(`${SSO_URL}${TABLEAU_REVENUE_GRAPH}/subscription`, { params });
      if (data) {
        setGraphLabel(data?.map((e) => e.label || ""));
        setGraphData(data?.map((e) => e.value || 0));
        setTooltipFormatter({ tooltipFormatter: (val) => `Subscriptions : ${val}` });
        sanitizeChartPropsBeforeDisplay(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getGeographicData = async () => {
    try {
      setLoading(true);
      let params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? dateRange[1] : null,
        filterName: tablueFilter?.filterName || "activity",
        filterValue: tablueFilter?.filterValue ?? null,
      };
      let data = await apiClient(`${SSO_URL}${TABLEAU_REVENUE_GRAPH}/geography`, { params });
      if (data) {
        const heatMapData = data?.map((item) => {
          return {
            id: item.label == "National Capital Territory of Delhi" ? "Delhi" : item.label,
            values: item.value,
          };
        });
        setHeapMap(heatMapData);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchIndustries = async () => {
    try {
      const response = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/1`);
      const data = response.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setDropDownValues(data);
    } catch (error) {
      console.log(error);
    }
  };

  const sanitizeChartPropsBeforeDisplay = (data) => {
    //checking For Any Chart where we need to show full categories/labels
    if (
      notShowFirstCharOptionsCharts?.includes(tablueFilter?.filterValue) ||
      notShowFirstCharOptionsCharts?.includes(tablueFilter?.filterName)
    ) {
      setShowFirstChar(() => false);
    } else {
      setShowFirstChar(() => true);
    }
    //checking For Any Custom ToolTip
    if (data[0]?.tooltip) {
      const tooltip = data?.map((e) => e.tooltip);
      setCustomToolTip(tooltip);
    } else {
      setCustomToolTip(null);
    }
    //Checking for Custom tooltips
    if (cutomToolTipFormatOptionsMap[`${activeTab}${tablueFilter.filterName}`]) {
      setTooltipFormatter(cutomToolTipFormatOptionsMap[`${activeTab}${tablueFilter.filterName}`]);
    }
  };

  useEffect(() => {
    if (activeTab === REVENUE) {
      getRevenueGraphData();
    } else if (activeTab === USER) {
      getUserGraphData();
    } else if (activeTab === SUBSCRIPTION) {
      getSubscriptionGraphData();
    } else if (activeTab === GEOGRAPHIC) {
      if (tablueFilter.filterName === "industry") {
        fetchIndustries();
      }
      getGeographicData();
    }
  }, [dateRange, tablueFilter]);

  useEffect(() => {
    setTablueFilter({});
    setHeapMap([]);
  }, [activeTab]);

  return (
    <>
      <div className="tablueParent">
        <div className="headOptions">
          {navBar.map((item) => (
            <span
              key={item.value}
              onClick={() => setActiveTab(item.key)}
              className={item.key === activeTab ? "active" : ""}
            >
              {item.title}
            </span>
          ))}
        </div>

        <div className="tablueContent">
          <div className="graphSide">
            {loading ? (
              <MuiLoader size={80} message={"Fetching Analytics..."} />
            ) : (
              <TableauGraphs
                graphLabel={graphLabel}
                graphData={graphData}
                activeTab={activeTab}
                activeGraphType={activeGraphType}
                tooltipFormatter={tooltipFormatter}
                showFirstChar={showFirstChar}
                customToolTip={customToolTip}
                heatMap={heatMap}
                tablueFilter={tablueFilter}
              />
            )}
          </div>
          <div className="filterSide">
            <TableauFilters
              activeTab={activeTab}
              setActiveGraphType={setActiveGraphType}
              setTablueFilter={setTablueFilter}
              dateRange={dateRange}
              dropDownValues={dropDownValues}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tableau;
